import React from 'react';
import { useTranslation } from 'react-i18next';
import AddButton from './AddButton';

const OtherCardItems = ({ s11Data, handleAddButton }) => {
  const { t } = useTranslation('deductions/other');

  return (
    <div className="cardWrapper">
      <div className="displayFlex cardWrapper1">
        <AddButton
          title={t('card.itemTitle1')}
          path="/deductions/otherDeductions/detail/type1"
          status={s11Data.htmSType == '1' ? 'active' : 'disabled'}
          onClick={() => handleAddButton('type1')}
        />
        <AddButton
          title={t('card.itemTitle2')}
          path="/deductions/otherDeductions/detail/type2"
          status={
            s11Data.htmSType == '1' && Number(s11Data.htm013) <= 80000000 ? 'active' : 'disabled'
          }
          onClick={() => handleAddButton('type2')}
        />
      </div>
      <div className="displayFlex cardWrapper1">
        <AddButton
          title={t('card.itemTitle3')}
          path="/deductions/otherDeductions/detail/type3"
          status="active"
          onClick={() => handleAddButton('type3')}
        />
        <AddButton
          title={t('card.itemTitle4')}
          path="/deductions/otherDeductions/detail/type4"
          status="active"
          onClick={() => handleAddButton('type4')}
        />
      </div>
      <AddButton
        title={t('card.itemTitle5')}
        path="/deductions/otherDeductions/detail/type5"
        status="readOnly"
        onClick={() => handleAddButton('type5')}
      />
    </div>
  );
};

export default OtherCardItems;
